import { NavigationMockApi } from 'app/mock-api/common/navigation/api';
import { CompanyMockApi } from 'app/mock-api/database/company/api';
import { VesselMockApi } from 'app/mock-api/database/vessel/api';
import { PortcallMockApi } from 'app/mock-api/port-operation/portcall/api';
import { PreArrivalNoticeMockApi } from 'app/mock-api/ship-shore-operation/pre-arrival-notice/api';
import { VesselCallMockApi } from 'app/mock-api/ship-shore-operation/vessel-call/api';

export const mockApiServices = [NavigationMockApi, CompanyMockApi, VesselMockApi, PortcallMockApi, VesselCallMockApi, PreArrivalNoticeMockApi];
